<template>
  <v-app>
    <CommonAppHeader />
    <v-main>
      <ClientOnly><ConnectivityBanner /></ClientOnly>
      <v-container>
        <slot />
      </v-container>
    </v-main>
    <CommonAppFooter />
  </v-app>
</template>
